import Helper from "../../functions/Helper.js";
import { createSlice } from "@reduxjs/toolkit";

const courtDimensions = {
  NBA: {
    length: 94,
    width: 50,
  },
  NCAA: {
    length: 94,
    width: 50,
  },
  HighSchool: {
    length: 84,
    width: 50,
  },
  FIBA: {
    length: 91.86,
    width: 49.21,
  },
};

const initialState = {
  description: null,
  youtubeUrl: "",
  version: Helper.modelVersion,
  courtColor: Helper.courtColors[0],
  tabIndex: 0,
  objectSizeFactor: 1,
  editor: {
    court: {
      type: "NCAA",
      width: 50,
      length: 94,
      sidelines: 3,
      full: false,
      gridSpacing: 6,
      showGridLines: false,
    },
  },
  videos: [],
};

const settings = createSlice({
  name: "settings",
  initialState,
  reducers: {
    updateModelVersion(state, action) {
      state.version = Helper.modelVersion;
    },
    loadSettings(state, action) {
      return {
        ...initialState,
        ...Helper.cleanSettingsForSave(action.payload.data.settings),
      };
    },
    changeCourtColor(state, action) {
      state.courtColor = action.payload;
    },
    changeObjectSizeFactor(state, action) {
      state.objectSizeFactor = action.payload;
    },
    changeYoutube(state, action) {
      state.youtubeUrl = action.payload;
    },

    changeDescriptionQuill(state, action) {
      state.description = action.payload;
    },
    resetSettings(state, action) {
      state.description = null;
      state.youtubeUrl = "";
      state.version = Helper.modelVersion;
      state.tabIndex = 0;
      state.videos = [];
    },
    changeCourt(state, action) {
      Helper.gaEvent("playcreator", "change_court");
      state.editor.court = {
        ...state.editor.court,
        ...action.payload,
        ...courtDimensions[action.payload.type],
      };
    },
    changeTab(state, action) {
      state.tabIndex = action.payload;
    },
    updatePrintSettings(state, action) {
      state.printSettings = action.payload;
    },
    toClipboard(state, action) {
      state.clipboard = action.payload;
    },
    addVideos(state, action) {
      let videos = action.payload.map((video) => {
        if (video.source === "youtube") {
          return video;
        } else
          return {
            guid: video.guid,
            source: video.source,
            title: video.title,
            library_id: video.library_id,
            upload_id: video.upload_id,
          };
      });

      if (!state.videos) state.videos = [];
      state.videos = [...state.videos, ...videos];
    },
    deleteVideo(state, action) {
      let index = action.payload;
      state.videos.splice(index, 1);
    },
    saveVideoNoteQuill(state, action) {
      let relevantVideo = state.videos[action.payload.index];
      relevantVideo.note = action.payload.note;
    },
  },
});

export default settings.reducer;
export const {
  loadSettings,
  changeCourtColor,
  changeYoutube,
  resetSettings,
  changeCourt,
  changeTab,
  updateModelVersion,
  changeDescriptionQuill,
  updatePrintSettings,
  toClipboard,
  changeObjectSizeFactor,
  addVideos,
  deleteVideo,
  saveVideoNoteQuill,
} = settings.actions;
